import { Column } from "@/components/common/Table";
import { TruncatedTableCell } from "@/components/common/TruncatedTableCell";

export const columns: Column<AdtAlert>[] = [
  {
    key: "eventdate",
    label: "Event Date",
    isSortable: false,
    cellClassName: "w-[100px] min-w-[100px]",
    headerClassName: "w-[100px] min-w-[100px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.eventdate || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "eventType",
    label: "Event Type",
    cellClassName: "w-[140px] min-w-[140px]",
    headerClassName: "w-[140px] min-w-[140px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.eventType || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "facility",
    label: "Facility",
    isSortable: false,
    cellClassName: "w-[180px] min-w-[180px] max-w-[180px]",
    headerClassName: "w-[180px] min-w-[180px] max-w-[180px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.facility || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "providerName",
    label: "Provider Name",
    cellClassName: "w-[100px] min-w-[100px]",
    headerClassName: "w-[100px] min-w-[100px]",
    isSortable: false,
    render: (row) => (
      <TruncatedTableCell
        content={row.providerName || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "diagnoses",
    label: "Event Description",
    cellClassName: "w-[250px] min-w-[250px] max-w-[250px]",
    headerClassName: "w-[250px] min-w-[250px] max-w-[250px]",
    isSortable: false,
    render: (row) => (
      <TruncatedTableCell
        content={row.diagnoses || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
];
